import './Marquee.css';

const ROW_A = [
  'React', 'Next.js', 'TypeScript', 'Node.js', 'Python', 'FastAPI',
  'PostgreSQL', 'MongoDB', 'Redis', 'Docker', 'Kubernetes',
];
const ROW_B = [
  'AWS', 'Google Cloud', 'Nginx', 'CI/CD', 'TensorFlow', 'Anthropic API',
  'Stripe', 'GraphQL', 'Linux', 'Terraform-ready', 'Observability',
];

const Row = ({ items, reverse }) => (
  <div className={`mq-row ${reverse ? 'mq-row--rev' : ''}`}>
    <div className="mq-track">
      {[...items, ...items, ...items].map((item, i) => (
        <span className="mq-item" key={`${item}-${i}`}>
          {item}
          <i className="mq-sep" />
        </span>
      ))}
    </div>
  </div>
);

export default function Marquee() {
  return (
    <div className="mq" aria-hidden="true">
      <Row items={ROW_A} />
      <Row items={ROW_B} reverse />
    </div>
  );
}
